// extracted by mini-css-extract-plugin
module.exports = {"sideButton":"styles_sideButton__23Ufk"};